export default function Underline() {

    return (
        <div className="text-sm">
            <div className="bg-amber-600 w-96 h-1 mt-5 mb-10"></div>
        </div >
    );
}
